import React from "react";
import Icon from "../Icon";
import { RowButton, RowIcon, RowTitle, RowSub, Check } from "./styles";

interface ChoiceRowProps {
  title: string;
  sub?: string;
  icon?: string;
  selected?: boolean;
  onClick: () => void;
  right?: React.ReactNode;
  last?: boolean;
}

export default function ChoiceRow({ title, sub, icon, selected, onClick, right, last }: ChoiceRowProps) {
  return (
    <RowButton type="button" aria-pressed={!!selected} onClick={onClick} $last={last}>
      {icon && (
        <RowIcon $selected={selected}>
          <Icon name={icon} size={18} />
        </RowIcon>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <RowTitle>{title}</RowTitle>
        {sub && <RowSub>{sub}</RowSub>}
      </div>
      {right}
      <Check $selected={selected}>
        {selected && <Icon name="check" size={14} color="#fff" strokeWidth={3} />}
      </Check>
    </RowButton>
  );
}
